import React, { FunctionComponent } from "react";
import { Text } from "../../text/text";

export interface FormFieldLabelProps {
  id: string;
  formFieldId: string;
  required: boolean;
  label: string;
  labelInfo?: string;
  className: string;
  labelRequiredIndicatorClassName: string;
  labelTextClassName: string;
  labelInfoClassName: string;
  labelProps?: React.HTMLAttributes<HTMLLabelElement>;
}

/**
 * @todo: [BDS-530] expose this as a top level component
 * move component specific classes from `FormField` to here
 */
export const FormFieldLabel: FunctionComponent<FormFieldLabelProps> = ({
  id,
  formFieldId,
  required,
  label,
  labelInfo,
  className,
  labelRequiredIndicatorClassName,
  labelTextClassName,
  labelInfoClassName,
  labelProps = {},
}) => (
  <span className={className}>
    {required ? (
      <Text className={labelRequiredIndicatorClassName} variant="label">
        *
      </Text>
    ) : null}
    <label htmlFor={formFieldId} id={id} className="flex items-baseline" {...labelProps}>
      <Text className={labelTextClassName} variant="label">
        {label}
      </Text>
      {labelInfo && (
        <Text className={labelInfoClassName} variant="caption">
          ({labelInfo})
        </Text>
      )}
    </label>
  </span>
);
